const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpinner(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 204.964,
    height: 204.964,
    viewBox: "0 0 54.23 54.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.688 -73.704)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17.427,
    cy: 100.819,
    r: 22.387,
    style: {
      fill: "none",
      stroke: "#999",
      strokeWidth: 4.09979,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.814 100.819a22.387 22.387 0 0 1-22.387 22.387",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 4.2,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeDasharray: "none"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.2579c3ef49c9fe3cc147688ec64a77a4.svg";
export { ForwardRef as ReactComponent };